import React, { useState } from "react";

function ProbaNav() {

  console.log('Here => ', process.env.PUBLIC_URL)

  return (
    <>
      {/* <fieldset className="mt-6 p-6 border border-gray-300 rounded-lg shadow-lg bg-gray-50 max-w-3xl mx-auto">
        <legend className="text-2xl font-bold text-gray-900 mb-4">Plan za mršavljenje:</legend>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          <div className="flex flex-col">
            <label className="text-md font-medium text-gray-700">Trajanje perioda (u mesecima):</label>
            <select
              value={selectedMonth}
              onChange={handleChange}
              className="mt-2 block w-full rounded-md border-gray-300 py-2 px-3 bg-white text-gray-900 shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            >
              {[1, 2, 3, 4, 5, 6].map((month) => (
                <option key={month} value={month}>
                  {month}
                </option>
              ))}
            </select>
          </div>

          <div className="flex flex-col">
            <label className="text-md font-medium text-gray-700">
              Predviđeni datum postizanja cilja:
            </label>
            <span className="mt-2 text-lg font-semibold text-blue-600">{calculateDate()}</span>
          </div>
        </div>

        <div className="mt-6">
          <label className="text-md font-medium text-gray-700">Željeni broj kilograma za mršavljenje:</label>
          <div className="flex items-center space-x-4 mt-2">
            <input
              type="number"
              name="brKilaDaSePromeni"
              id="brKilaDaSePromeni"
              value={brKilaDaSePromeni}
              onChange={handleWeightChange}
              className="w-full sm:w-24 rounded-md border-gray-300 py-2 px-3 bg-white text-gray-900 shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              placeholder="Unesite kg"
              min="0"
            />
            <span className="text-md font-medium text-gray-700">kg</span>
          </div>
        </div>

        <div className="mt-6">
          <label className="text-md font-medium text-gray-700">
            Vaša trenutna kilaža: <span className="font-semibold text-blue-600">{kilazaIspisana} kg</span>
          </label>
        </div>

        <div className="mt-6 bg-white p-4 rounded-lg shadow-inner border border-gray-200">
          <h3 className="text-lg font-semibold text-gray-800 mb-4">Rezultati vašeg plana:</h3>
          <p className="text-md font-medium text-gray-700">
            Nakon <span className="font-semibold text-blue-600">{selectedMonth}</span> meseca, vaša ciljana težina biće
            <span className="font-semibold text-blue-600"> {calculateTargetWeight()} kg</span>.
          </p>
          <p className="text-md font-medium text-gray-700">
            Dnevni deficit kalorija:{" "}
            <span className="font-semibold text-blue-600">
              {brKilaDaSePromeni ? calculateDailyChange() : "N/A"}
            </span>{" "}
            kalorija po danu.
          </p>
        </div>
      </fieldset>

      <fieldset className="mt-6 p-6 border border-gray-300 rounded-lg shadow-lg bg-gray-50 max-w-3xl mx-auto">
        <legend className="text-2xl font-bold text-gray-900 mb-4">Plan za gojenje:</legend>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          <div className="flex flex-col">
            <label className="text-md font-medium text-gray-700">Trajanje perioda (u mesecima):</label>
            <select
              value={selectedMonth}
              onChange={handleChange}
              className="mt-2 block w-full rounded-md border-gray-300 py-2 px-3 bg-white text-gray-900 shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            >
              {[1, 2, 3, 4, 5, 6].map((month) => (
                <option key={month} value={month}>
                  {month}
                </option>
              ))}
            </select>
          </div>

          <div className="flex flex-col">
            <label className="text-md font-medium text-gray-700">
              Predviđeni datum postizanja cilja:
            </label>
            <span className="mt-2 text-lg font-semibold text-blue-600">{calculateDate()}</span>
          </div>
        </div>

        <div className="mt-6">
          <label className="text-md font-medium text-gray-700">Željeni broj kilograma za gojenje:</label>
          <div className="flex items-center space-x-4 mt-2">
            <input
              type="number"
              name="brKilaDaSePromeni"
              id="brKilaDaSePromeni"
              value={brKilaDaSePromeni}
              onChange={handleWeightChange}
              className="w-full sm:w-24 rounded-md border-gray-300 py-2 px-3 bg-white text-gray-900 shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              placeholder="Unesite kg"
              min="0"
            />
            <span className="text-md font-medium text-gray-700">kg</span>
          </div>
        </div>

        <div className="mt-6">
          <label className="text-md font-medium text-gray-700">
            Vaša trenutna kilaža: <span className="font-semibold text-blue-600">{kilazaIspisana} kg</span>
          </label>
        </div>

        <div className="mt-6 bg-white p-4 rounded-lg shadow-inner border border-gray-200">
          <h3 className="text-lg font-semibold text-gray-800 mb-4">Rezultati vašeg plana:</h3>
          <p className="text-md font-medium text-gray-700">
            Nakon <span className="font-semibold text-blue-600">{selectedMonth}</span> meseca, vaša ciljana težina biće
            <span className="font-semibold text-blue-600"> {calculateTargetWeight()} kg</span>.
          </p>
          <p className="text-md font-medium text-gray-700">
            Dnevni kalorijski višak:{" "}
            <span className="font-semibold text-blue-600">
              {brKilaDaSePromeni ? calculateDailyChange() : "N/A"}
            </span>{" "}
            kalorija po danu.
          </p>
        </div>
      </fieldset> */}


    
    </>

  );
}

export default ProbaNav;
